import { render, staticRenderFns } from "./formInput.vue?vue&type=template&id=4a38168c"
import script from "./formInput.vue?vue&type=script&lang=js"
export * from "./formInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports